<template>
    <defaultSec title="售后分类与路由管理">
        <el-alert
            class="config-alert"
            title="新工单使用本页配置；历史工单仍读取旧分类树。配置仅停用不删除，已生成的稳定编码不可修改。"
            type="warning"
            :closable="false"
            show-icon>
        </el-alert>

        <el-tabs v-model="activeTab" type="border-card">
            <el-tab-pane label="售后问题" name="issues">
                <div class="toolbar">
                    <el-button type="primary" size="mini" @click="editIssue()">新增售后问题</el-button>
                </div>
                <el-table v-loading="loading" :data="configs.issues" border size="mini">
                    <el-table-column type="index" label="序号" width="55"></el-table-column>
                    <el-table-column prop="issueGroupName" label="问题大类" width="90"></el-table-column>
                    <el-table-column prop="issueName" label="具体问题" min-width="150"></el-table-column>
                    <el-table-column prop="issueCode" label="稳定编码" min-width="210"></el-table-column>
                    <el-table-column label="处理人" min-width="110">
                        <template slot-scope="scope">
                            <span v-if="scope.row.issueGroupCode === 'LOGISTICS'">
                                {{userNameById(scope.row.responsibleUserId)}}
                            </span>
                            <span v-else class="muted-text">由路由配置</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="责任部门" min-width="120">
                        <template slot-scope="scope">
                            <span v-if="scope.row.issueGroupCode === 'LOGISTICS'">
                                {{deptNameById(scope.row.responsibleDeptDingdingId)}}
                            </span>
                            <span v-else class="muted-text">由路由配置</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="sortNo" label="排序" width="70"></el-table-column>
                    <el-table-column label="状态" width="75">
                        <template slot-scope="scope">
                            <el-tag size="mini" :type="scope.row.enabled === 1 ? 'success' : 'info'">
                                {{scope.row.enabled === 1 ? '启用' : '停用'}}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" min-width="180" show-overflow-tooltip></el-table-column>
                    <el-table-column label="操作" fixed="right" width="90">
                        <template slot-scope="scope">
                            <el-button type="primary" plain size="mini" @click="editIssue(scope.row)">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>

            <el-tab-pane label="产品线配置" name="productLines">
                <div class="toolbar">
                    <el-button type="primary" size="mini" @click="editProductLine()">新增产品线</el-button>
                    <span class="toolbar-tip">产品线仅与温层关联，不再关联工厂。</span>
                </div>
                <el-table v-loading="loading" :data="configs.productLineConfigs" border size="mini">
                    <el-table-column type="index" label="序号" width="55"></el-table-column>
                    <el-table-column label="温层" width="75">
                        <template slot-scope="scope">
                            <el-tag size="mini" :type="scope.row.temperatureZone === 'COLD' ? '' : 'success'">
                                {{temperatureZoneText(scope.row.temperatureZone)}}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="productLineName" label="产品线" min-width="130"></el-table-column>
                    <el-table-column prop="productLineCode" label="产品线编码" min-width="190"></el-table-column>
                    <el-table-column prop="sortNo" label="排序" width="70"></el-table-column>
                    <el-table-column label="状态" width="75">
                        <template slot-scope="scope">
                            <el-tag size="mini" :type="scope.row.enabled === 1 ? 'success' : 'info'">
                                {{scope.row.enabled === 1 ? '启用' : '停用'}}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" min-width="180" show-overflow-tooltip></el-table-column>
                    <el-table-column label="操作" fixed="right" width="90">
                        <template slot-scope="scope">
                            <el-button type="primary" plain size="mini" @click="editProductLine(scope.row)">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>

            <el-tab-pane label="工厂负责人配置" name="factoryRoutes">
                <div class="toolbar"><el-button type="primary" size="mini" @click="editFactoryRoute()">新增工厂负责人</el-button><span class="toolbar-tip">同一工厂可配置多个负责人。</span></div>
                <el-table v-loading="loading" :data="configs.factoryRoutes" border size="mini">
                    <el-table-column prop="factoryName" label="工厂" min-width="140"/><el-table-column prop="factoryCode" label="工厂编码" min-width="180"/>
                    <el-table-column label="负责人" min-width="110"><template slot-scope="scope">{{userNameById(scope.row.responsibleUserId)}}</template></el-table-column>
                    <el-table-column label="责任部门" min-width="120"><template slot-scope="scope">{{deptNameById(scope.row.responsibleDeptDingdingId)}}</template></el-table-column>
                    <el-table-column prop="sortNo" label="排序" width="70"/><el-table-column label="状态" width="75"><template slot-scope="scope"><el-tag size="mini" :type="scope.row.enabled === 1 ? 'success' : 'info'">{{scope.row.enabled === 1 ? '启用' : '停用'}}</el-tag></template></el-table-column>
                    <el-table-column prop="remark" label="备注" min-width="160"/><el-table-column label="操作" width="90"><template slot-scope="scope"><el-button type="primary" plain size="mini" @click="editFactoryRoute(scope.row)">编辑</el-button></template></el-table-column>
                </el-table>
            </el-tab-pane>

            <el-tab-pane label="店铺路由" name="shopRoutes">
                <div class="toolbar">
                    <el-button type="primary" size="mini" @click="editShopRoute()">新增店铺路由</el-button>
                    <span class="toolbar-tip">店铺编码必须与 ERP 订单返回的 shopCode 一致。</span>
                </div>
                <el-table v-loading="loading" :data="configs.shopRoutes" border size="mini">
                    <el-table-column type="index" label="序号" width="55"></el-table-column>
                    <el-table-column prop="shopName" label="店铺" min-width="150"></el-table-column>
                    <el-table-column prop="shopCode" label="店铺编码" min-width="160"></el-table-column>
                    <el-table-column prop="platformName" label="平台" min-width="100"></el-table-column>
                    <el-table-column prop="platformCode" label="平台编码" min-width="120"></el-table-column>
                    <el-table-column label="处理人" min-width="110">
                        <template slot-scope="scope">{{userNameById(scope.row.responsibleUserId)}}</template>
                    </el-table-column>
                    <el-table-column label="责任部门" min-width="120">
                        <template slot-scope="scope">{{deptNameById(scope.row.responsibleDeptDingdingId)}}</template>
                    </el-table-column>
                    <el-table-column prop="sortNo" label="排序" width="70"></el-table-column>
                    <el-table-column label="状态" width="75">
                        <template slot-scope="scope">
                            <el-tag size="mini" :type="scope.row.enabled === 1 ? 'success' : 'info'">
                                {{scope.row.enabled === 1 ? '启用' : '停用'}}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" min-width="180" show-overflow-tooltip></el-table-column>
                    <el-table-column label="操作" fixed="right" width="90">
                        <template slot-scope="scope">
                            <el-button type="primary" plain size="mini" @click="editShopRoute(scope.row)">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>

        <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            width="620px">
            <el-form :model="formData" label-width="105px" size="small">
                <template v-if="dialogType === 'issue'">
                    <el-form-item label="问题大类" required>
                        <el-select v-model="formData.issueGroupCode" :disabled="Boolean(formData.id)" style="width: 100%">
                            <el-option
                                v-for="item in issueGroupOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="具体问题" required>
                        <el-input v-model="formData.issueName" maxlength="50" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item v-if="formData.id" label="稳定编码">
                        <el-input v-model="formData.issueCode" disabled></el-input>
                    </el-form-item>
                    <template v-if="formData.issueGroupCode === 'LOGISTICS'">
                        <el-form-item label="处理人" required>
                            <el-select v-model="formData.responsibleUserId" filterable clearable style="width: 100%" placeholder="请选择">
                                <el-option
                                    v-for="item in userList"
                                    :key="item.USER_ID"
                                    :label="userDisplayName(item)"
                                    :value="item.USER_ID">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="责任部门">
                            <el-select v-model="formData.responsibleDeptDingdingId" filterable clearable style="width: 100%" placeholder="请选择">
                                <el-option
                                    v-for="item in deptList"
                                    :key="item.key"
                                    :label="item.name"
                                    :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </template>
                    <el-alert
                        v-else
                        class="dialog-alert"
                        title="质量问题的处理人由质量路由确定，运营问题的处理人由店铺路由确定。"
                        type="info"
                        :closable="false">
                    </el-alert>
                </template>

                <template v-if="dialogType === 'productLine'">
                    <el-form-item label="温层" required>
                        <el-select v-model="formData.temperatureZone" :disabled="Boolean(formData.id)" style="width: 100%">
                            <el-option label="低温" value="COLD"></el-option>
                            <el-option label="常温" value="AMBIENT"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="产品线名称" required>
                        <el-input v-model="formData.productLineName" maxlength="64"></el-input>
                    </el-form-item>
                    <el-form-item label="产品线编码" required><el-input v-model="formData.productLineCode" :disabled="Boolean(formData.id)" maxlength="64"/></el-form-item>
                </template>
                <template v-if="dialogType === 'factoryRoute'">
                    <el-form-item label="工厂名称" required><el-input v-model="formData.factoryName" maxlength="64"/></el-form-item>
                    <el-form-item label="工厂编码" required><el-input v-model="formData.factoryCode" :disabled="Boolean(formData.id)" maxlength="64"/></el-form-item>
                    <el-form-item label="处理人" required>
                        <el-select v-model="formData.responsibleUserId" filterable clearable style="width: 100%" placeholder="请选择">
                            <el-option
                                v-for="item in userList"
                                :key="item.USER_ID"
                                :label="userDisplayName(item)"
                                :value="item.USER_ID">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="责任部门">
                        <el-select v-model="formData.responsibleDeptDingdingId" filterable clearable style="width: 100%" placeholder="请选择">
                            <el-option
                                v-for="item in deptList"
                                :key="item.key"
                                :label="item.name"
                                :value="item.key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </template>

                <template v-if="dialogType === 'shopRoute'">
                    <el-form-item label="店铺编码" required>
                        <el-input v-model="formData.shopCode" :disabled="Boolean(formData.id)" maxlength="64"></el-input>
                    </el-form-item>
                    <el-form-item label="店铺名称" required>
                        <el-input v-model="formData.shopName" maxlength="100"></el-input>
                    </el-form-item>
                    <el-form-item label="平台编码">
                        <el-input v-model="formData.platformCode" maxlength="64"></el-input>
                    </el-form-item>
                    <el-form-item label="平台名称">
                        <el-input v-model="formData.platformName" maxlength="100"></el-input>
                    </el-form-item>
                    <el-form-item label="处理人" required>
                        <el-select v-model="formData.responsibleUserId" filterable clearable style="width: 100%" placeholder="请选择">
                            <el-option
                                v-for="item in userList"
                                :key="item.USER_ID"
                                :label="userDisplayName(item)"
                                :value="item.USER_ID">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="责任部门">
                        <el-select v-model="formData.responsibleDeptDingdingId" filterable clearable style="width: 100%" placeholder="请选择">
                            <el-option
                                v-for="item in deptList"
                                :key="item.key"
                                :label="item.name"
                                :value="item.key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </template>

                <el-form-item label="排序">
                    <el-input-number v-model="formData.sortNo" :min="0" :max="999999"></el-input-number>
                </el-form-item>
                <el-form-item label="状态">
                    <el-switch
                        v-model="formData.enabled"
                        :active-value="1"
                        :inactive-value="0"
                        active-text="启用"
                        inactive-text="停用">
                    </el-switch>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="formData.remark" type="textarea" :rows="3" maxlength="255" show-word-limit></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button size="small" @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" size="small" :loading="saving" @click="saveConfig">保存</el-button>
            </span>
        </el-dialog>
    </defaultSec>
</template>

<script>
import defaultSec from '@c/defaultSection'

export default {
    name:'workOrderType',
    components:{
        defaultSec,
    },
    data(){
        return {
            activeTab:'issues',
            loading:false,
            saving:false,
            componentDestroyed:false,
            configRequestSeq:0,
            dialogVisible:false,
            dialogType:'issue',
            formData:{},
            userList:[],
            deptList:[],
            configs:{
                issues:[],
                qualityRoutes:[],
                productLineConfigs:[],
                factoryRoutes:[],
                shopRoutes:[],
            },
            issueGroupOptions:[
                {value:'LOGISTICS',label:'物流'},
                {value:'QUALITY',label:'质量'},
                {value:'OPERATION',label:'运营'},
            ],
        }
    },
    computed:{
        dialogTitle(){
            const prefix = this.formData.id ? '编辑' : '新增'
            return `${prefix}${{issue:'售后问题',qualityRoute:'质量路由',productLine:'产品线',factoryRoute:'工厂负责人',shopRoute:'店铺路由'}[this.dialogType]}`
        },
    },
    mounted(){
        this.loadConfigs()
        this.loadUsers()
        this.loadDepartments()
    },
    beforeDestroy(){
        this.componentDestroyed = true
        this.configRequestSeq += 1
    },
    methods:{
        loadConfigs(){
            const requestSeq = ++this.configRequestSeq
            this.loading = true
            this.$apiGet('lechun-csms/workOrder/classification/configs',{}).then(res => {
                if(this.componentDestroyed || requestSeq !== this.configRequestSeq) return
                this.configs = {
                    issues:(res && res.issues) || [],
                    qualityRoutes:(res && res.qualityRoutes) || [],
                    productLineConfigs:(res && res.productLineConfigs) || [],
                    factoryRoutes:(res && res.factoryRoutes) || [],
                    shopRoutes:(res && res.shopRoutes) || [],
                }
            }).finally(() => {
                if(this.componentDestroyed || requestSeq !== this.configRequestSeq) return
                this.loading = false
            })
        },
        loadUsers(){
            this.$apiGet('lechun-baseservice/user/getUserListForDorpbox',{}).then(res => {
                if(this.componentDestroyed) return
                this.userList = res || []
            })
        },
        loadDepartments(){
            this.$apiGet('lechun-csms/workOrder/getWorkOrderResponseDept',{}).then(res => {
                if(this.componentDestroyed) return
                this.deptList = res || []
            })
        },
        userDisplayName(user){
            return user ? (user.USER_NAME || user.USER_NICK || user.USER_ID) : '-'
        },
        userNameById(userId){
            if(!userId) return '-'
            const user = this.userList.find(item => String(item.USER_ID) === String(userId))
            return user ? this.userDisplayName(user) : userId
        },
        deptNameById(deptId){
            if(!deptId) return '-'
            const dept = this.deptList.find(item => String(item.key) === String(deptId))
            return dept ? dept.name : deptId
        },
        temperatureZoneText(value){
            return {COLD:'低温',AMBIENT:'常温'}[value] || value || '-'
        },
        editIssue(row){
            this.dialogType = 'issue'
            this.formData = row ? {...row} : {
                issueGroupCode:'LOGISTICS',
                issueName:'',
                responsibleDeptDingdingId:'',
                responsibleUserId:'',
                sortNo:0,
                enabled:1,
                remark:'',
            }
            this.dialogVisible = true
        },
        editQualityRoute(row){
            this.dialogType = 'qualityRoute'
            this.formData = row ? {...row} : {
                temperatureZone:'COLD',
                productLineName:'',
                factoryName:'',
                responsibleDeptDingdingId:'',
                responsibleUserId:'',
                sortNo:0,
                enabled:1,
                remark:'',
            }
            this.dialogVisible = true
        },
        editProductLine(row){ this.dialogType='productLine'; this.formData=row ? {...row} : {temperatureZone:'COLD',productLineCode:'',productLineName:'',sortNo:0,enabled:1,remark:''}; this.dialogVisible=true },
        editFactoryRoute(row){ this.dialogType='factoryRoute'; this.formData=row ? {...row} : {factoryCode:'',factoryName:'',responsibleUserId:'',responsibleDeptDingdingId:'',sortNo:0,enabled:1,remark:''}; this.dialogVisible=true },
        editShopRoute(row){
            this.dialogType = 'shopRoute'
            this.formData = row ? {...row} : {
                shopCode:'',
                shopName:'',
                platformCode:'',
                platformName:'',
                responsibleDeptDingdingId:'',
                responsibleUserId:'',
                sortNo:0,
                enabled:1,
                remark:'',
            }
            this.dialogVisible = true
        },
        validateForm(){
            const form = this.formData
            if(this.dialogType === 'issue'){
                if(!form.issueGroupCode) return '请选择问题大类'
                if(!(form.issueName || '').trim()) return '请输入具体问题'
                if(form.issueGroupCode === 'LOGISTICS' && !form.responsibleUserId){
                    return '物流问题必须配置处理人'
                }
            }
            if(this.dialogType === 'qualityRoute'){
                if(!form.temperatureZone) return '请选择温层'
                if(!(form.productLineName || '').trim()) return '请输入产品线名称'
                if(!(form.factoryName || '').trim()) return '请输入工厂名称'
                if(!form.responsibleUserId) return '请选择处理人'
            }
            if(this.dialogType === 'productLine' && (!(form.temperatureZone) || !(form.productLineCode || '').trim() || !(form.productLineName || '').trim())) return '温层、产品线编码和名称不能为空'
            if(this.dialogType === 'factoryRoute' && (!(form.factoryCode || '').trim() || !(form.factoryName || '').trim() || !form.responsibleUserId)) return '工厂编码、名称和负责人不能为空'
            if(this.dialogType === 'shopRoute'){
                if(!(form.shopCode || '').trim()) return '请输入店铺编码'
                if(!(form.shopName || '').trim()) return '请输入店铺名称'
                if(!form.responsibleUserId) return '请选择处理人'
            }
            return ''
        },
        saveConfig(){
            if(this.saving) return
            const error = this.validateForm()
            if(error){
                this.$message.warning(error)
                return
            }
            const url = {
                issue:'lechun-csms/workOrder/classification/issue/save',
                qualityRoute:'lechun-csms/workOrder/classification/qualityRoute/save',
                productLine:'lechun-csms/workOrder/classification/productLine/save',
                factoryRoute:'lechun-csms/workOrder/classification/factoryRoute/save',
                shopRoute:'lechun-csms/workOrder/classification/shopRoute/save',
            }[this.dialogType]
            this.saving = true
            this.$apiPost(url,{...this.formData}).then(() => {
                if(this.componentDestroyed) return
                this.$message.success('配置已保存')
                this.dialogVisible = false
                this.loadConfigs()
            }).finally(() => {
                if(this.componentDestroyed) return
                this.saving = false
            })
        },
    },
}
</script>

<style scoped lang="scss">
.config-alert {
    margin-bottom: 12px;
}

.toolbar {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.toolbar-tip {
    margin-left: 12px;
    color: #909399;
    font-size: 12px;
}

.muted-text {
    color: #909399;
}

.dialog-alert {
    margin-bottom: 18px;
}
</style>
